import { InjectionToken } from '@angular/core';
import type { Observable } from 'rxjs';
import type { DrfPaginatedResponse } from '../../../core/models/api.model';
import type { AssembleeGenerale } from '../../../core/models/gouvernance/assemblee-generale.model';

/** Pagination de lecture des assemblées générales (sous-ensemble consommé par Dividendes). */
export type AgListQuery = {
    page: number;
    per_page: number;
};

/**
 * Port (hexagonal) exposant au module Dividendes (Performance) les seules lectures d'assemblées
 * générales dont il a besoin, sans dépendre du service concret du module Gouvernance (audit R-33).
 * L'implémentation (adaptateur) vit dans `gouvernance/services` et est câblée au composition
 * root (`app.config`) via le token `AG_PROVIDER`.
 */
export type AgProvider = {
    /** Une page d'assemblées générales (le consommateur agrège les pages via `fetchAll`). */
    list(query: AgListQuery): Observable<DrfPaginatedResponse<AssembleeGenerale>>;
    /** Une assemblée générale par identifiant. */
    retrieve(id: string): Observable<AssembleeGenerale>;
};

/** Jeton DI du port AG — fourni par `AgProviderAdapter` (module Gouvernance) au composition root. */
export const AG_PROVIDER = new InjectionToken<AgProvider>('AG_PROVIDER');
